export default __webpack_public_path__ + "static/media/Condiciones generales.7659d0a7.pdf";